import React from 'react'

const Login = () => {
  return (
    <section className='section'>
      <div className='container mx-auto'>
        {/* title */}
        <h2
          className='h2 mb-10 lg:mb-20 text-center text-black'
          data-aos='fade-up'
          data-aos-delay='200'
        >
         LOGIN
        </h2>
    </div>
    </section>
  )
}

export default Login
